import {h, Fragment} from "preact"
import { useProductFilters } from '@nosto/preact'

export default () => {
    const { filters, removeAll } = useProductFilters()

    return (
        filters.length > 0 && (
            <div class="ns-selected-filters-mobile ns-d-flex ns-flex-wrap ns-align-items-center ns-pr-2">
                <div class="ns-d-flex ns-flex-wrap ns-align-items-center">
                    {filters.map((filter) => (
                        <div class="ns-selected-filter ns-d-flex ns-align-items-center ns-font-4">
                            <span>
                                {filter.name}: {filter.value}
                            </span>
                            <button
                                class="ns-act-btn ns-text-align-right ns-align-items-center ns-clickable ns-p-1 ns-color-grey"
                                onClick={() => filter.remove()}>
                                ×
                            </button>
                        </div>
                    ))}
                </div>
                <a
                    href="javascript:void(0)"
                    class="ns-d-flex ns-align-items-center ns-clear-filters ns-text-undecorated"
                    onClick={() => {
                        removeAll()
                    }}>
                    Clear All
                    <button class="ns-clear-filters-btn ns-act-btn ns-text-align-right ns-align-items-center ns-clickable ns-p-1 ns-color-grey">
                        ×
                    </button>
                </a>
            </div>
        )
    )
}
